import moment, { RelativeTimeSpec } from 'moment';

import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/da';
import 'moment/locale/he';
import 'moment/locale/es';
import 'moment/locale/en-gb';
import i18n from 'i18n';

let lang = localStorage.getItem('i18nextLng');

// transform lang code for Hebrew
if (lang === 'iw') {
  lang = 'he';
}

if (lang) {
  moment.locale(lang);
}

export const useMomentShort = (mode: 'cropped' | 'full' = 'cropped') => {
  const short = moment;

  const isCropped = mode === 'cropped';

  short.locale('en', {
    relativeTime: ({
      future: 'a few seconds ago',
      s: isCropped ? '1s' : 'a few seconds',
      ss: isCropped ? '%ds' : '%d seconds',
      m: isCropped ? '1m' : '1 minute',
      mm: isCropped ? '%dm' : '%d minutes',
      h: isCropped ? '1h' : '1 hour',
      hh: isCropped ? '%dh' : '%d hours',
      d: isCropped ? '1d' : '1 day',
      dd: (days: number) => {
        const weeks = Math.floor(days / 7);

        return days >= 7
          ? `${weeks}${
              isCropped ? 'w' : ` ${i18n.t('week', { count: weeks })}`
            }`.toLocaleLowerCase()
          : `${days}${isCropped ? 'd' : ` ${i18n.t('day', { count: days })}`}`.toLocaleLowerCase();
      },
      w: isCropped ? '1w' : '1 week',
      ww: isCropped ? '%dw' : '%d weeks',
      M: isCropped ? '4w' : `4 weeks`,
      MM: (months: number) =>
        `${Math.floor(months * 4)}${isCropped ? 'w' : `${Math.floor(months / 4)} weeks`}`,
      y: isCropped ? '1y' : 'a year',
      yy: isCropped ? '%dy' : '%d years',
    } as unknown) as RelativeTimeSpec,
  });

  return short;
};

export default moment;
